/* Same GSAP settings that were inline in theme.liquid; now a deferred file so it still runs right after animations.min.js. */
gsap.defaults({
  ease: Power4.easeOut
});
gsap.config({
  nullTargetWarn: false
});
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
